"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_ROUTE = void 0;
exports.TEMPLATE_ROUTE = {
    FREE_QSWP6C: 'FREE_QSWP6C',
    FREE_APP_V1: 'FREE_APP_V1',
    FREE_BOLD_V1: 'FREE_BOLD_V1',
    FREE_BOLD_V6: 'FREE_BOLD_V6',
    FREE_QUIZ_V1: 'FREE_QUIZ_V1',
    FREE_QSWP4D: 'FREE_QSWP4D',
    STRAIGHT_QUIZ_V1: 'STRAIGHT_QUIZ_V1',
    STRAIGHT_QSWP6C: 'STRAIGHT_QSWP6C'
};
//# sourceMappingURL=templateRoute.js.map